import { useFormikContext } from "formik"
import styles from "../../../styles/Form.module.css"

export default function OrganizationId({ field, index }) {
  const formik = useFormikContext()

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
